"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _brightnessAndContrastAdjustment = require("./brightnessAndContrastAdjustment");

Object.keys(_brightnessAndContrastAdjustment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _brightnessAndContrastAdjustment[key];
    }
  });
});

var _changesDetection = require("./changesDetection");

Object.keys(_changesDetection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _changesDetection[key];
    }
  });
});

var _crop = require("./crop");

Object.keys(_crop).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _crop[key];
    }
  });
});

var _gammaCorrection = require("./gammaCorrection");

Object.keys(_gammaCorrection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _gammaCorrection[key];
    }
  });
});

var _grayscale = require("./grayscale");

Object.keys(_grayscale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _grayscale[key];
    }
  });
});

var _histogramEqualization = require("./histogramEqualization");

Object.keys(_histogramEqualization).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _histogramEqualization[key];
    }
  });
});

var _histogramSpecification = require("./histogramSpecification");

Object.keys(_histogramSpecification).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _histogramSpecification[key];
    }
  });
});

var _imageResampling = require("./imageResampling");

Object.keys(_imageResampling).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _imageResampling[key];
    }
  });
});

var _imageResizing = require("./imageResizing");

Object.keys(_imageResizing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _imageResizing[key];
    }
  });
});

var _imageRotation = require("./imageRotation");

Object.keys(_imageRotation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _imageRotation[key];
    }
  });
});

var _imagesDifference = require("./imagesDifference");

Object.keys(_imagesDifference).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _imagesDifference[key];
    }
  });
});

var _imageTranspose = require("./imageTranspose");

Object.keys(_imageTranspose).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _imageTranspose[key];
    }
  });
});

var _interpolationMethods = require("./interpolationMethods");

Object.keys(_interpolationMethods).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _interpolationMethods[key];
    }
  });
});

var _linearTransformation = require("./linearTransformation");

Object.keys(_linearTransformation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _linearTransformation[key];
    }
  });
});

var _mirrorOperations = require("./mirrorOperations");

Object.keys(_mirrorOperations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _mirrorOperations[key];
    }
  });
});

var _quantization = require("./quantization");

Object.keys(_quantization).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _quantization[key];
    }
  });
});

var _transformImage = require("./transformImage");

Object.keys(_transformImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _transformImage[key];
    }
  });
});

var _sepia = require("./sepia");

Object.keys(_sepia).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sepia[key];
    }
  });
});

var _hueRotation = require("./hueRotation");

Object.keys(_hueRotation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _hueRotation[key];
    }
  });
});

var _saturate = require("./saturate");

Object.keys(_saturate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _saturate[key];
    }
  });
});